import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { createAction, props } from '@ngrx/store'
import { ChangeItem, FetchDeliverablePayload } from '../../model'
import { DiffResult } from '../../util/get-item-changes.util'

export enum ChangeRequestDeliverableActionTypes {
  FETCH_DELIVERABLE = '[Change Request] Fetch Deliverable',

  MODIFY_DELIVERABLE = '[Change Request] Modify Deliverable',
  MODIFY_DELIVERABLE_SUCCESS = '[Change Request] Modify Deliverable Success',
  MODIFY_DELIVERABLE_FAIL = '[Change Request] Modify Deliverable Fail',

  ADD_DELIVERABLE = '[Change Request] Add Deliverable',
  ADD_DELIVERABLE_SUCCESS = '[Change Request] Add Deliverable Success',
  ADD_DELIVERABLE_FAIL = '[Change Request] Add Deliverable Fail',

  DELETE_DELIVERABLE = '[Change Request] Delete Deliverable',
  DELETE_DELIVERABLE_SUCCESS = '[Change Request] Delete Deliverable Success',
  DELETE_DELIVERABLE_FAIL = '[Change Request] Delete Deliverable Fail',
  REVERT_DELETED_DELIVERABLE = '[Change Request] Revert Deleted Deliverable',

  SET_MAPPED_DELIVERABLES = '[Change Request] Set Mapped Deliverables',
  SET_MAPPED_TRACKED_DELIVERABLES = '[Change Request] Set Mapped Tracked Deliverables',
}

const fetchDeliverable = createAction(
  ChangeRequestDeliverableActionTypes.FETCH_DELIVERABLE,
  props<FetchDeliverablePayload>()
)

const modifyDeliverable = createAction(
  ChangeRequestDeliverableActionTypes.MODIFY_DELIVERABLE,
  props<{ identity: number; changes: DiffResult<Deliverable> }>()
)
const modifyDeliverableSuccess = createAction(
  ChangeRequestDeliverableActionTypes.MODIFY_DELIVERABLE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const modifyDeliverableFail = createAction(
  ChangeRequestDeliverableActionTypes.MODIFY_DELIVERABLE_FAIL,
  props<{ error: Error }>()
)

const addDeliverable = createAction(ChangeRequestDeliverableActionTypes.ADD_DELIVERABLE, props<{ data: Deliverable }>())
const addDeliverableSuccess = createAction(
  ChangeRequestDeliverableActionTypes.ADD_DELIVERABLE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const addDeliverableFail = createAction(
  ChangeRequestDeliverableActionTypes.ADD_DELIVERABLE_FAIL,
  props<{ error: Error }>()
)

const deleteDeliverable = createAction(
  ChangeRequestDeliverableActionTypes.DELETE_DELIVERABLE,
  props<{ deliverableId: number }>()
)
const deleteDeliverableSuccess = createAction(
  ChangeRequestDeliverableActionTypes.DELETE_DELIVERABLE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const deleteDeliverableFail = createAction(
  ChangeRequestDeliverableActionTypes.DELETE_DELIVERABLE_FAIL,
  props<{ error: Error }>()
)
const revertDeletedDeliverable = createAction(
  ChangeRequestDeliverableActionTypes.REVERT_DELETED_DELIVERABLE,
  props<{ deliverableId: number }>()
)

const setMappedDeliverables = createAction(
  ChangeRequestDeliverableActionTypes.SET_MAPPED_DELIVERABLES,
  props<{ deliverables: Deliverable[] }>()
)
const setMappedTrackedDeliverables = createAction(
  ChangeRequestDeliverableActionTypes.SET_MAPPED_TRACKED_DELIVERABLES,
  props<{ deliverables: Deliverable[] }>()
)

export const ChangeRequestDeliverableActions = {
  fetchDeliverable,

  modifyDeliverable,
  modifyDeliverableSuccess,
  modifyDeliverableFail,

  addDeliverable,
  addDeliverableSuccess,
  addDeliverableFail,

  deleteDeliverable,
  deleteDeliverableSuccess,
  deleteDeliverableFail,
  revertDeletedDeliverable,

  setMappedDeliverables,
  setMappedTrackedDeliverables,
}
